import "../../assets/css/chosen/photo-consent.css";
import { Say } from "../../languages";
import appSettings from "../../settings/appSettings";
const { urls, chosenAuthStatement } = appSettings;
const privacyNoticeUrl = `${urls.core}/privacy-notice`;

export function PhotoConsentOption({ checked, onChange, disabled = false, visible = false }) {
  if (!visible) {
    return null;
  }

  const onCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <div className="photoconsent__option">
      <label>
        <input
          type="checkbox"
          name="photoConsent"
          disabled={disabled}
          onChange={onCheckboxChange}
          checked={checked}
        />
        <Say
          phrase="photo_step.auth_statement"
          mutator={(value) => value.replace("{{privacyNoticeUrl}}", privacyNoticeUrl)}
          renderHtml={true}
          dynamicValue={chosenAuthStatement}
        />
      </label>
    </div>
  );
}

export default PhotoConsentOption;
